import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { isLoggedInState } from '../../storage/app';

const ZENDESK_SCRIPT_ID = 'ze-snippet';

let zeReadyPromise: Promise<any> | null = null;

function loadZendeskScript(src: string) {
  if (document.getElementById(ZENDESK_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = ZENDESK_SCRIPT_ID;
  script.src = src;
  script.async = true;

  document.body.appendChild(script);
}

function getZE(): Promise<any> {
  if (zeReadyPromise) return zeReadyPromise;

  zeReadyPromise = new Promise((resolve, reject) => {
    const start = Date.now();
    const timeout = 5000;

    const interval = setInterval(() => {
      const zE = (globalThis as any)?.zE;

      if (zE) {
        clearInterval(interval);
        resolve(zE);
      }

      if (Date.now() - start > timeout) {
        clearInterval(interval);
        console.warn('Zendesk zE did not load within timeout');
        reject(new Error('Zendesk failed to load'));
      }
    }, 50);
  });

  return zeReadyPromise;
}

function ZEProvider() {
  const zeKey = process.env.REACT_APP_ZE_KEY;
  const isEnabled = zeKey && process.env.REACT_APP_ZE_VISIBILITY === 'visible';
  const zeUrl = `https://static.zdassets.com/ekr/snippet.js?key=${zeKey}`;
  const isLoggedIn = useRecoilValue(isLoggedInState);

  useEffect(() => {
    if (!isEnabled) return;
    loadZendeskScript(zeUrl);
  }, [isEnabled, zeUrl]);

  useEffect(() => {
    if (!isEnabled) return;

    getZE()
      .then((zE) => {
        if (isLoggedIn) {
          zE('webWidget', 'show');
        } else {
          zE('webWidget', 'hide');
        }
      })
      .catch(() => {
        // TODO
      });
  }, [isLoggedIn, isEnabled]);

  return null;
}

export default ZEProvider;
